<template>
  <div class="query-study">
    <div class="query-select">
      <p class="area">{{area}}</p>
      <div v-for="(model,index) in models" :key="index">
        <span>{{model.name}}</span>
        <el-select
          v-model="model.value"
          clearable
          placeholder="请选择"
          @change="change(model.name,index,model.value)"
        >
          <el-option
            v-for="(item,index) in model.options"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
    </div>
    <studyTable :tableData="tableDataTemp" :columns="columns" :pages="pages"></studyTable>
  </div>
</template>
<script>
import studyTable from "./module/_studyTable";

export default {
  data() {
    return {
      area: "东坡区",
      models: [
        { name: "乡镇", value: "", options: [] },
        { name: "村社区", value: "", options: [] },
        { name: "人名", value: "", options: [] }
      ],
      pages: 1,
      tableData: [],
      columns: [
        { name: "所在地区", prop: "town" },
        { name: "学习人", prop: "name" },
        { name: "学习方式", prop: "typename" },
        { name: "学习信息", prop: "title" }
      ],
      tableDataTemp: []
    };
  },
  components: {
    studyTable
  },
  methods: {
    getMsg() {
      this.tableDataTemp = [];
      this.axios
        .post("/api/Statistics/DataShow", {
          c2town: sessionStorage.getItem('roleid')==3?sessionStorage.getItem('town'):"东坡区",
          c1status: sessionStorage.getItem('roleid')==3?1:0,
          c2name: sessionStorage.getItem("token")
        })
        .then(e => {
          console.log("parent", e.data);
          if (e.data.code == 0) {
            this.tableData = e.data.msg;
            this.pages = Number.parseInt(
              e.data.msg.length % 10 == 0
                ? e.data.msg.length / 10
                : e.data.msg.length / 10 + 1
            );
            for (let x in this.tableData) {
              if (x == 10) return;
              else this.tableDataTemp.push(this.tableData[x]);
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getTown() {
      
      let  getVillage = ()=>{
        this.models[0].value=sessionStorage.getItem('town')
        this.axios.get(
          `/api/Login/Village?township=${this.models[0].value}`,
        ).then(e=>{
          switch (e.data.code) {
            case 0:
              e.data.msg.filter(item => {
                  this.models[1].options.push({
                    value: item.Town,
                    label: item.Town
                  });
                });
              break;
          
            default:
              break;
          }
        })
      }
      sessionStorage.getItem('roleid')==3?getVillage():"";


      this.axios
        .get("/api/Login/Township")
        .then(e => {
          // console.log(e.data);
          switch (e.data.code) {
            case 0:
              e.data.msg.filter(item => {
                this.models[0].options.push({
                  value: item.TownShip1,
                  label: item.TownShip1
                });
              });

              break;

            default:
              break;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    change(name, index, value) {
      switch (name) {
        case "乡镇":
          this.models[1].value = "";
          this.models[2].value = "";
          break;
        case "村社区":
          this.models[2].value = "";
          break;
        default:
          break;
      }

      let juris = [
        "/api/Login/Township",
        `/api/Login/Village?township=${this.models[index].value}`,
        `/api/Statistics/Pesonal?town=${this.models[index].value}`
      ];
      let param = ["TownShip1", "Town", "c2name"];
      if (juris[index] != undefined) {
        // console.log(juris[index+1]);
        this.axios
          .get(juris[index + 1])
          .then(e => {
            console.log(e.data);
            switch (e.data.code) {
              case 0:
                e.data.msg.filter(item => {
                  this.models[index + 1].options.push({
                    value: item[param[index + 1]],
                    label: item[param[index + 1]]
                  });
                });
                break;
              default:
                break;
            }
          })
          .catch(err => {
            console.log("err", err);
          });
      }

      this.axios
        .post("/api/Statistics/DataShow", {
          c2town: value,
          c1status: index + 1,
          c2name: sessionStorage.getItem("token")
        })
        .then(e => {
          this.tableDataTemp = [];
          console.log(e.data);

          if (e.data.code == 0) {
            this.tableData = e.data.msg;
            this.pages = Number.parseInt(
              e.data.msg.length % 10 == 0
                ? e.data.msg.length / 10
                : e.data.msg.length / 10 + 1
            );
            for (let x in this.tableData) {
              if (x == 10) return;
              else this.tableDataTemp.push(this.tableData[x]);
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    this.getMsg();
    this.getTown();
  }
};
</script>
<style lang='scss' scoped>
.query-study {
  .query-select {
    div {
      span {
        width: 20%;
        text-align: center;
        margin-right: 0.2rem;
      }
      .el-select {
        width: 70%;
      }
      align-items: center;
      display: flex;
      line-height: 3;
    }
    .area {
      text-align: center;
      line-height: 3;
    }
  }

  padding-top: 1rem;
  font-size: 0.3rem;
  background: #fff;
  min-height: 100vh;
}
</style>
<style lang="scss">
.query-study {
  .el-select {
    input {
      font-size: 0.3rem;
    }
  }
}
</style>